import html2canvas from "html2canvas";
import { useContext, useEffect } from "react";
import { log_mercure, sendScreenshot } from "../../api/screen";
import { root_rotate, screenToken } from "../../config/constant";
import { DisplayModeContext } from "../../context/displayMode";
import { sendDataToApp } from "../../utils/android";
import { clearCache, getItem, setItem } from "../../utils/storage";
import { withMercure } from "../HOC/withMercure";

const MercureLayout = ({ subscribeTopics, mercureData, children, reloadApp }) => {
  const displayMode = useContext(DisplayModeContext)
  const token = getItem(screenToken)

  async function startCapture(id) {
    const node = document.body
    const displayedScanning = node.getElementsByClassName('displayed-scanning')[0]
    const hasAnimation = displayedScanning?.getElementsByClassName('has-animations')[0]

    if (hasAnimation) {
      hasAnimation.classList.remove('has-animations')
      hasAnimation.classList.add('direct-display')
    }

    displayedScanning?.classList.remove('displayed-scanning')
    const canvas = await html2canvas(node);
    const image = canvas.toDataURL("image/png", 1.0).split(',')[1];
    image.replaceAll('data:image/png;base64,', '')
    displayedScanning?.classList.add('displayed-scanning')

    if (hasAnimation) {
      hasAnimation.classList.remove('direct-display')
      hasAnimation.classList.add('has-animations')
    }

    sendScreenshot(image, id)
        .then((response) => console.log(response))
        .catch((error) => console.error(error))
  }

  const executeMercure = () => {
    switch(mercureData.type){
      case "rejected_screen":
        if (typeof AndroidInterface !== "undefined") {
          sendDataToApp('hard_reload')
        } else {
          setItem(screenToken, mercureData.screen.token)
          reloadApp();
        }

        break;
      case "accepted_screen":
        setItem(screenToken, mercureData.screen.token)
        reloadApp();
        break;
      case "refresh_screen":
        reloadApp();
        break;
      case "fullscreen": {
        const rootElem = document.getElementById("root");
        rootElem.requestFullscreen().then(event => console.log(event)).catch(error => console.log(error));
        break;
      }
      case "dev_mode":
        displayMode.switchMode()
        break;
      case "flush_keys":
        clearCache();
        break;
      case "preview_shot_screen":
        startCapture(mercureData?.screen?.id)
        break;
      case "rotate_screen": {
        const { rotate = 0 } = mercureData?.screen?.config?.root_config ?? {};
        const currentRotate = getItem(root_rotate);

        if (currentRotate != rotate) {
          setItem(root_rotate, `${rotate}`);
          reloadApp();
        }

        break;
      }
    }
  }

  useEffect(() => {
    if (! mercureData?.type) {
      return;
    }

    if (token) {
      log_mercure(mercureData?.type, subscribeTopics)
        .then((response) => console.log(response))
        .catch((error) => console.error(error))
        .finally(() => executeMercure());
    } else {
      executeMercure();
    }

  }, [mercureData]);

  return (<>{children}</>)
}

export default withMercure(MercureLayout);
